<template>
<w-settings-content-template side-title="서버 목록">
  <w-physical-tree slot="sideContent" ref="sideTree" managetype-id="SMS" force-select-leaf @clickNode="onClickNode"/>
  <div slot="content">
    <w-file-change-list-view :selectPhysicalNode="selectPhysicalNode"></w-file-change-list-view>
  </div>
</w-settings-content-template>
</template>

<script>
import WFileChangeListView from '@/views/settings/server/FileDetectSettings/FileChangeDetectView/component/FileChangeListView';
import WPhysicalTree from '@/components/tree/DynamicPhysicalTree';
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';

export default {
  name: 'WFileChangeDetectView',
  components: {
    WPhysicalTree,
    WFileChangeListView,
    WSettingsContentTemplate,
  },
  data() {
    return {
      selectPhysicalNode: null,
    };
  },
  methods: {
    onClickNode(data) {
      this.selectPhysicalNode = data;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/server/FileDetectSettings/FileChangeDetectView/component/FileChangeDetectView.vue